import { render, staticRenderFns } from "./kubota.vue?vue&type=template&id=3ad54f76&"
import script from "./kubota.vue?vue&type=script&lang=js&"
export * from "./kubota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports